import { Button } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { Card } from "./Card";
import { mobileQuery } from "./MediaQuery";
import { SizedBox } from "./SizedBox";
import { translation } from "./translations";
import { Paragraph1 } from "./typography";

export const CookieConsent: React.FC<{
  visible: boolean;
  onAccept: () => void;
  children?: React.ReactNode;
}> = (props) => (
  <>
    {props.visible && (
      <>
        <Overlay />
        <CookieCard>
          <Paragraph1>{translation.cookiesConsent}</Paragraph1>

          <SizedBox height={32} />

          <Center>
            <AcceptButton
              variant="outlined"
              color="primary"
              onClick={props.onAccept}
            >
              {translation.cookiesAccept}
            </AcceptButton>
          </Center>
        </CookieCard>
      </>
    )}

    {props.children}
  </>
);

const Overlay = styled.div`
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
`;

const CookieCard = styled(Card)`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  width: 425px;
  margin: 0;
  border-radius: 8px;
  text-align: center;

  ${mobileQuery`
    border-radius: 8px 8px 0 0;
    top: inherit;
    left: 0;
    right: 0;
    bottom: 0;
    transform: inherit;
    width: inherit;

    p {
      max-width: 425px;
      margin: 0 auto;
    }
  `}
`;

const AcceptButton = styled(Button)`
  margin-top: 0;
`;

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
